import { LastModifiedButton } from '@michelin/changelogs-ui';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import { ChangeLogEntities } from 'Types';
import { changeLogsEndpoint } from 'Types/APITypes';

interface Props {
  entity: ChangeLogEntities;
}

function LastModified({ entity }: Props) {
  const { stNumber, btNumber } = useParams<{ stNumber: string, btNumber: string }>();
  const history = useHistory();

  return (
    <LastModifiedButton
      api={changeLogsEndpoint}
      entity={entity}
      identifier={stNumber || btNumber}
      filters={{ bill_to_number: btNumber }}
      callback={() => {
        history.push(`/${btNumber}/change-history/${stNumber || 'all'}/list#entity=${entity}`);
      }}
    />
  );
}

export default LastModified;
